import { WSElement, WSFlexBox, WSText } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../../query/payments/queries";
import { BadgePayoutPreference } from "../../Settings/components/BadgePayoutPreference";
import { LabelMethod } from "../../Settings/components/LabelMethod";
import { useDefaultPayoutMethod } from "../../Settings/components/payout/DefaultPayoutMethod";
import styles from "./EmbeddedDefaultPayoutMethod.module.scss";

export const EmbeddedDefaultPayoutMethod = () => {
  const userId = useUserId();
  const queryPayoutSettings = useQueryPayoutSettings(userId);
  const defaultPayoutMethod = useDefaultPayoutMethod();

  if (queryPayoutSettings.isLoading) {
    return <WSElement shimmer className={styles.shimmer} />;
  }

  if (!defaultPayoutMethod) {
    return <WSText color="gray400">No payout method set</WSText>;
  }

  return (
    <WSFlexBox justify="space-between" alignItems="center" wrap="nowrap">
      <LabelMethod
        type={defaultPayoutMethod.type}
        id={defaultPayoutMethod.id}
      />
      {queryPayoutSettings.data && (
        <BadgePayoutPreference
          payoutPreference={queryPayoutSettings.data.payoutPreferences}
        />
      )}
    </WSFlexBox>
  );
};
